import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import placeholder from '../../assets/videoImgs/thumbshot1.jpg';
import PieChart from 'react-minimal-pie-chart';

import api from '../../utils/api';

class LectureTile extends Component {
    render(){
        let {videoClass, iconClass, lecture, chapterIndex, lectureIndex} = this.props;
        
        return (
            <span className="video-item-wrapper loading-item">
                <div className={`swiper-slide video-item loading-tile`} onClick={(e) => {
                    if(videoClass !== 'video-locked'){
                        this.props.history.push(`/video/item/${lecture.id}`);
                    }
                }}>
                    <div className={`loading-tile-inner step-${this.props.step}`}></div>
                    
                    <Link to={``}><i className={''}></i></Link>
                    

                    
                    <img src={placeholder} alt="Video" />

                    

                    <div className="video-item-name">
                        <Link to={``}>Loading</Link>

                        
                        
                    
                    </div>



                </div>
                
            </span>
        )
        
    }
}

export default LectureTile;


// WEBPACK FOOTER //
// ./src/components/Video/LoadingTile.js